import { render } from "./ContaminationDetails.vue?vue&type=template&id=442ae1a4&scoped=true"
import script from "./ContaminationDetails.vue?vue&type=script&lang=ts"
export * from "./ContaminationDetails.vue?vue&type=script&lang=ts"

import "./ContaminationDetails.vue?vue&type=style&index=0&id=442ae1a4&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-442ae1a4"

export default script